// GET /admin/shift-requests/:id/candidate-caregivers — the eligible-only picker
// list for the operator manual-target flow. Server-side filters to caregivers
// who pass ALL four hard gates (isHardEligible: active + role + setting + valid
// credentials) for this request, so the operator only ever sees professionals
// they can actually target — no ineligible clutter, and no client-side page cap
// dropping caregivers at scale. Kept in its own resource file per Convention 06.
import { z } from 'zod';
export const AdminCandidateCaregiverSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    email: z.string(),
    /** Service-area → shift-location haversine (null when either is un-geocoded). */
    distanceKm: z.number().nullable(),
    /** Caregiver-declared travel radius — shown so the operator sees when a manual
     *  target asks someone past their normal max (which the lever overrides). */
    maxTravelKm: z.number().int(),
    /** Does the caregiver's declared availability cover THIS shift's window? Uses
     *  the exact `coversShiftWindow` full-coverage check the auto-matcher applies
     *  (matching/availability-match.ts). Like distance, this ANNOTATES only — the
     *  operator lever still targets anyone (availability is a soft filter the lever
     *  overrides; the operator confirms out-of-band). */
    availabilityMatchesShift: z.boolean(),
    /** Whether the caregiver has set ANY availability at all. Lets the UI tell
     *  "set windows that don't include this slot" (a real not-available signal)
     *  apart from "hasn't set any availability yet" (neutral — say nothing strong). */
    hasAvailabilityOnFile: z.boolean(),
});
export const AdminCandidateCaregiversResponseSchema = z.object({
    items: z.array(AdminCandidateCaregiverSchema),
});
//# sourceMappingURL=candidate-caregivers.schema.js.map